import React, { ComponentPropsWithRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends ComponentPropsWithRef<'div'> {}

export const Col = (p: Props) => {
  const { className, ...rest } = p;
  return <div className={twMerge('col-auto', className)}>{p.children}</div>;
};
